import {useParams} from "react-router-dom"
import React, {PropsWithChildren} from "react"
import {kebabCase, startCase} from "lodash"
import classNames from "classnames"
import TitleBar, {MetaItemProps} from "../../components/TitleBar/TitleBar"
import {ReceivedPayment} from "../../resources/receivedPayments"
import {useIsUnitUser} from "../../services/auth"
import {useListReturnPath} from "../../hooks/useListReturnPath"

interface ReceivedPaymentTitleBarProps {
	receivedPayment: ReceivedPayment
	leftSideClassName?: string
	className?: string
}
export default function ReceivedPaymentTitleBar({
	receivedPayment,
	leftSideClassName,
	className,
	children,
}: PropsWithChildren<ReceivedPaymentTitleBarProps>) {
	const listReturnPath = useListReturnPath("/received-payments/")
	const {receivedPaymentId = ""} = useParams<{receivedPaymentId: string}>()
	const isUnitUser = useIsUnitUser()

	const accountId = receivedPayment.relationships.account?.data.id
	const customerId = receivedPayment.relationships.customer?.data.id
	const receivedPaymentTransactionId = receivedPayment.relationships.receivePaymentTransaction?.data.id
	const incomingAchItemId =
		"incomingAchItem" in receivedPayment.relationships
			? receivedPayment.relationships.incomingAchItem?.data.id
			: undefined
	const incomingWireId =
		"incomingWire" in receivedPayment.relationships ? receivedPayment.relationships.incomingWire?.data.id : undefined

	return (
		<TitleBar
			title={`${startCase(receivedPayment.type).replace("Received Payment", "")} #${receivedPaymentId}`}
			breadcrumbs={[{text: "Received Payments", path: listReturnPath}]}
			status={{
				text: startCase(receivedPayment.attributes.status),
				className: classNames("incoming-payments-status", kebabCase(receivedPayment.attributes.status)),
			}}
			meta={[
				...(accountId
					? [
							{
								text: "Account",
								icon: "bank-account--business-products",
								path: `/accounts/${accountId}`,
							} as MetaItemProps,
					  ]
					: []),
				...(customerId
					? [
							{
								text: "Customer",
								icon: "user-geometric-action-money-fund---users",
								path: `/customer/${customerId}`,
							} as MetaItemProps,
					  ]
					: []),
				...(accountId && receivedPaymentTransactionId
					? [
							{
								text: "Transaction",
								icon: "money-transfer--business-products",
								path: `/transaction/${accountId}/${receivedPaymentTransactionId}`,
							} as MetaItemProps,
					  ]
					: []),
				...(incomingAchItemId && isUnitUser
					? [
							{
								text: "Incoming ACH",
								icon: "money-transfer--business-products",
								path: `/incoming-achs/${incomingAchItemId}`,
							} as MetaItemProps,
					  ]
					: []),
				...(incomingWireId && isUnitUser
					? [
							{
								text: "Incoming Wire",
								icon: "money-transfer--business-products",
								path: `/incoming-wires/${incomingWireId}`,
							} as MetaItemProps,
					  ]
					: []),
			]}
			leftSideClassName={leftSideClassName}
			className={className}
		>
			{children}
		</TitleBar>
	)
}
